import { object } from 'yup';

export const workloadSchema = object().shape({});

export const workweekSchema = object().shape({});
